/**
 * Utilidades de validación y sanitización
 */

/**
 * Sanitiza un string removiendo caracteres peligrosos
 */
export function sanitizeString(input: string): string {
  if (typeof input !== 'string') {
    return ''
  }
  
  return input
    .trim()
    .replace(/[<>]/g, '') // Remover < y >
    .replace(/javascript:/gi, '') // Remover javascript:
    .replace(/on\w+=/gi, '') // Remover event handlers
    .slice(0, 255) // Limitar longitud
}

/**
 * Valida formato de email
 */
export function isValidEmail(email: string): boolean {
  if (!email || typeof email !== 'string') {
    return false
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email.trim())
}

/**
 * Valida fortaleza de contraseña
 */
export function isStrongPassword(password: string): boolean {
  if (!password || typeof password !== 'string') {
    return false
  }
  
  // Mínimo 8 caracteres, al menos una letra y un número
  if (password.length < 8) {
    return false
  }
  
  const hasLetter = /[a-zA-Z]/.test(password)
  const hasNumber = /[0-9]/.test(password)
  
  return hasLetter && hasNumber
}

/**
 * Sanitiza y valida email
 */
export function sanitizeAndValidateEmail(email: string): { valid: boolean; sanitized: string; error?: string } {
  const sanitized = sanitizeString(email)
  
  if (!sanitized) {
    return { valid: false, sanitized: '', error: 'Email is required' }
  }
  
  if (!isValidEmail(sanitized)) {
    return { valid: false, sanitized: '', error: 'Invalid email format' }
  }
  
  return { valid: true, sanitized: sanitized.toLowerCase() }
}

/**
 * Sanitiza nombre (solo letras, espacios y algunos caracteres especiales)
 */
export function sanitizeName(name: string): string {
  if (typeof name !== 'string') {
    return ''
  }
  
  return name
    .trim()
    .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s'-]/g, '') // Solo letras, espacios, guiones y apostrofes
    .replace(/\s+/g, ' ') // Normalizar espacios múltiples
    .slice(0, 100) // Limitar longitud
}


